/**
 * Public deck registry
 * ------------------------------------------------------------------
 * This file is the ONLY place client builds load deck code from.
 * Add a deck here ONLY if its meta.ts has `audience: 'public'`.
 *
 * Internal-only decks must never be imported in this file. The
 * audit check in `audit.ts` enforces this at build time and will
 * fail the build if a mismatch is found.
 *
 * The static imports here are what makes tree-shaking work: a deck
 * not referenced from this file is physically absent from a client
 * bundle, not merely hidden by UI logic.
 */
import type { DeckEntry } from './registry';
import DeckV3 from './nanza/v3-subtle/Deck';
import { meta as metaV3 } from './nanza/v3-subtle/meta';

export const publicDecks: DeckEntry[] = [
  { ...metaV3, component: DeckV3 },
];

export function findPublicDeck(id: string): DeckEntry | undefined {
  return publicDecks.find((d) => d.id === id);
}
